// extracted by mini-css-extract-plugin
export default {"fs":"dc99beb59e _963b08f308"};